import styled from 'styled-components';

export const Container = styled.div`
    grid-area: CT;

    padding: 25px;

    height: calc(100vh - 70px);
    overflow-y: scroll;
`;
